import { QuantityPicker } from '@components';
import { Button, Container, Icon, Typography } from '@design-system';
import { DEFAULT_IMAGE, formatUnit } from '@utils';
import React from 'react';
import { BiPlus } from 'react-icons/bi';
import { IoMdClose } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';
import './CartDisplayer.scss';
import { CartDisplayerProps } from './CartDisplayer.types';

export const CartDisplayer: React.FC<CartDisplayerProps> = ({
    items,
    onRemoveItem,
    onUpdateQuantity,
    readOnly = false,
    onAddProduct,
    type = 'appro'
}) => {
    const navigate = useNavigate();

    const navigateToCategories = () => {
        if (type === 'epi') {
            navigate('/sante-securite/epi');
        } else {
            navigate('/mes-chantiers/approvisionnement');
        }
    };

    if (items.length === 0) {
        return (
            <Container className="cart-displayer" padding="none" column>
                <Container className="cart-item center" padding="small-medium" column>
                    <div className="item-container">
                        <Typography intrinsic="h4" variant="secondary" color="grey">
                            Votre panier est vide
                        </Typography>
                    </div>
                </Container>
                <Container padding="small-medium" column>
                    <Button
                        color="green"
                        variant="secondary"
                        size="small"
                        icon={<BiPlus />}
                        iconPosition="left"
                        iconSize={24}
                        onClick={() => {
                            onAddProduct?.();
                            if (!onAddProduct) {
                                navigateToCategories();
                            }
                        }}
                    >
                        <Typography intrinsic="h4">Ajouter un produit</Typography>
                    </Button>
                </Container>
            </Container>
        );
    }

    return (
        <Container className="cart-displayer" padding="none" column>
            {items.map((item) => (
                <Container key={item.id} className={`cart-item ${readOnly ? 'read-only' : ''}`} padding="small-medium" column>
                    <div className="item-container">
                        <img src={item.image ?? DEFAULT_IMAGE} alt={item.label} className="item-image" />

                        <div className="item-info">
                            <Typography intrinsic="h5" color="marine" className="item-label">
                                {item.label}
                            </Typography>

                            {readOnly && (
                                <Typography intrinsic="p" variant="secondary" color="grey" className="item-quantity">
                                    x{item.quantity}
                                </Typography>
                            )}

                            <div className="bottom-container">
                                <Typography intrinsic="p" variant="secondary" color="grey" className="item-unit">
                                    {formatUnit(item.packing_unit)}
                                </Typography>
                            </div>
                        </div>

                        {!readOnly && (
                            <Icon
                                className="remove-button"
                                icon={<IoMdClose />}
                                size={24}
                                color="grey"
                                onClick={() => onRemoveItem(item.id)}
                            />
                        )}
                    </div>

                    {!readOnly && (
                        <QuantityPicker
                            quantity={Number(item.quantity)}
                            onQuantityChange={(quantity) => onUpdateQuantity(item.id, quantity)}
                        />
                    )}
                </Container>
            ))}
            {!readOnly && (
                <Container padding="small-medium" column>
                    <Button
                        color="green"
                        variant="secondary"
                        size="small"
                        icon={<BiPlus />}
                        iconPosition="left"
                        iconSize={24}
                        onClick={() => {
                            onAddProduct?.();
                            if (!onAddProduct) {
                                navigateToCategories();
                            }
                        }}
                    >
                        <Typography intrinsic="h4">Ajouter un produit</Typography>
                    </Button>
                </Container>
            )}
        </Container>
    );
};
